<template>
  <div>
    <div id="qianduanwz" class="qianduanwz" v-if="pageStatue == 2">
      <img class="bg" :src="Tool.pubPach+'end/e'+userData.you.data.lists[0].tid+'_'+userData.pic+'.png'" >
      <div class="tx">
        <img :src="userData.you.data.lists[0].headimgurl" >
      </div>
      <div class="name">{{userData.you.data.lists[0].nickname}}</div>
      <div class="num">{{setNum(userData.you.data.lists[0].dist)}}</div>
      <img class="ewm" :src="Tool.pubPach+'end/ewm.png'" >
    </div>
    <div :class="pageCls">
      <img class="d1" v-if="!!userData.base64" :src="userData.base64" >
      <div class="qianduanwz qianduanwz2">
        <div v-if="pageStatue == 1 || pageStatue == 3">
          <img class="bg" :src="Tool.pubPach+'end/e'+userData.sel1+'_'+userData.pic+'.png'" >
          <div class="tx">
            <img :src="userData.me.tx" >
          </div>
          <div class="name">{{userData.me.name}}</div>
          <div class="num">{{userData.juNum}}</div>
        </div>
        <div v-if="pageStatue == 2">
          <img class="bg" :src="Tool.pubPach+'end/e'+userData.you.data.lists[0].tid+'_'+userData.pic+'.png'" >
          <div class="tx">
            <img :src="userData.you.data.lists[0].headimgurl" >
          </div>
          <div class="name">{{userData.you.data.lists[0].nickname}}</div>
          <div class="num">{{setNum(userData.you.data.lists[0].dist)}}</div>
        </div>
        
        <div class="che"></div>
      
      </div>
      <div v-if="!!userData.base64" class="d2"></div>
      <div class="d3" v-if="(pageStatue == 2 || pageStatue == 3) && (!!userData.you.data.lists && userData.you.data.lists.length>1)">
        <div class="b1"></div>
        <div v-show="index>0" :class="getItemCls(userData.you.data.lists[0].dist , item.dist)" :key="index" v-for="(item,index) in userData.you.data.lists" :style="{zIndex:1000-index}">
          <img class="ut" :src="userData.you.data.lists[0].headimgurl" >
          <div class="un">{{userData.you.data.lists[0].nickname}}</div>
          <div class="num">{{setNum2(userData.you.data.lists[0].dist , item.dist)}}</div>
          <img class="pt" :src="item.headimgurl" >
          <div class="pn">{{item.nickname}}</div>
        </div>
      </div>

      <div class="d4" v-if="pageStatue == 1 || pageStatue == 3">
        <div class="btn1">
          <span @click="$emit('resetPage2')"></span>
          <span @click="shareClick"></span>
        </div>
      </div>
      <div class="d4" v-if="pageStatue == 2 && userData.me.name != userData.you.data.details.nickname && getStatusNum==0">
        <div class="btn2">
          <span @click="$emit('resetPage')"></span>
        </div>
      </div>

      <div class="d5" v-if="shoreTipShow" @click="shoreTipShow=false"></div>
    </div>
  </div>
</template>

<script>
import Tool from '../script/tool.js'
export default {
  name: 'Page6',
  props: {
    userData: Object
  },
  data(){
    return{
      pageStatue:1,
      pageCls:"page6",
      Tool:Tool,
      shoreTipShow:false,
      getStatusNum: 0,
    }
  },
  mounted(){
    let that = this;
    console.log(this.userData)
    //打开页面拖动
    document.querySelector(".page6").addEventListener('touchmove', function (e) {
      e.stopPropagation();
    });
    if(that.userData.sel1 == 0 && !!that.userData.you.pid){
      that.pageStatue = 2;
      that.getStatus();
      that.cPic();
      window.shareData={
          MsgImg:'http://cms-bucket.ws.126.net/2022/0126/2f4520b8j00r6aut2001cc0005k005kc.jpg',  //分享图片
          link:location.origin+location.pathname + '?pid=' + encodeURIComponent(that.userData.you.pid),    //分享链接
          title:that.userData.you.data.lists[0].nickname+'的社交人设竟然是这样的? !',   //分享标题
          desc:'快来测一测你们之间的安全距离！',    //分享描述
          fText:that.userData.you.data.lists[0].nickname+'的社交人设竟然是这样的? !',    //分享朋友圈
          callback:function(){
              window.share_survey(true);
          }
      };
      window.NeteaseShareInit();
    }
    if(that.userData.sel1 > 0 && !!that.userData.you.pid){
      that.pageStatue = 3;
    }
    that.postData();
  },
  methods:{
    cPic(){
      let that = this;
      setTimeout(() => {
        (window.html2canvas || html2canvas)(document.getElementById('qianduanwz'),{
          dpi: 300,
          allowTaint: true,
          useCORS: true 
        }).then(function(canvas) {
          that.$emit('setUser',"base64",canvas.toDataURL());
        });
      }, 100);
    },
    getItemCls(n,n2){
      // 两个人测出来的值相加就是最终结果
      // 3-6米（命中之人  没你不行）
      // 6-10米  (相性吻合  灵魂伴侣)
      // 10-15米  (各自安好  距离产生美 )
      // 15-21米(君子之交淡如水)
      // 21-38米(命里犯冲  远离为好)

      // 3-8
      // 8-13
      // 13-20
      // 20-28
      // 28-38

      n = (n*10 + n2*10)/10;
      // console.log(n)

      if(n <= 8){
        return 'item item1'
      }
      if(n <= 13){
        return 'item item2'
      }
      if(n <= 20){
        return 'item item3'
      }
      if(n <= 28){
        return 'item item4'
      }
      return 'item item5'
    },
    setNum(tem){
      tem = parseInt(tem * 10)/10;
      if((""+tem).indexOf(".")==-1){
        tem+='.0';
      }
      return tem;
    },
    setNum2(tem,tem2){
      tem = parseInt(tem * 10) + parseInt(tem2 * 10);
      tem = parseInt(tem)/10;
      if((""+tem).indexOf(".")==-1){
        tem+='.0';
      }
      return tem;
    },
    shareClick(){
      this.shoreTipShow=true;
      if(this.pageStatue==3){
        this.postData(true);
      }
    },
    getStatus(){
      let that = this;
      this.$http.post(Tool.urlData.getStatus,{
          sess: localStorage.getItem('sess'),
          pid: that.userData.you.pid
      },{emulateJSON:true}).then(({data})=>{
        if(typeof data == "string"){
          data = JSON.parse(data);
        }
        if(data.retCode!=1 && data.retCode!=-5){
            return Tool.login();
        }else{
          if(data.retCode==-5){
            that.getStatusNum = 1;
          }
        }
      });
    },
    postData(n){
      let that = this;
      if(that.pageStatue==1 || that.pageStatue==3){
        this.$http.post(Tool.urlData.addInfo,{
            sess: localStorage.getItem('sess'),
            tid: that.userData.sel1,
            dist: that.userData.juNum,
            pid: n ? "" :that.userData.you.pid
            // sess 身份标识 
            // tid 关系类别 1 2 3 对应 朋友、职场、家庭 
            // dist 距离 
            // pid 通过URL获取的父级ID，不存在时为空
        },{emulateJSON:true}).then(({data})=>{
          if(typeof data == "string"){
            data = JSON.parse(data);
          }
          if(data.retCode!=1){
              return Tool.login();
          }else{
            if(that.pageStatue==3){
              that.$emit('setPid');
            }
            if(that.pageStatue==1 || !!n){
              window.shareData={
                  MsgImg:'http://cms-bucket.ws.126.net/2022/0126/2f4520b8j00r6aut2001cc0005k005kc.jpg',  //分享图片
                  link:location.origin+location.pathname + '?pid=' + encodeURIComponent(data.retData),    //分享链接
                  title:that.userData.me.name+'的社交人设竟然是这样的? !',   //分享标题
                  desc:'快来测一测你们之间的安全距离！',    //分享描述
                  fText:that.userData.me.name+'的社交人设竟然是这样的? !',    //分享朋友圈
                  callback:function(){
                      window.share_survey(true);
                  }
              };
              window.NeteaseShareInit();
            }
          }
        });
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:0.75;
.page6{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  overflow-y: auto;
  background: url(../assets/bg92.png) repeat-y 0 0 / 100% auto;
  z-index: 10;
  .d1{
    position: absolute;
    left:0;
    top:0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .d2{
    width: 100%;
  }
  .qianduanwz2{
    position: relative;
    height: 13.5rem;
    overflow: hidden;
    margin-top: -0.8rem;
    .che{
      position: absolute;
      right:0;
      bottom:0.5rem;
      width: 6.98rem;
      height: 0.9rem;
      background: url(../assets/bg104.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .btn1{
    position: fixed;
    left:0;
    bottom:0;
    width: 100%;
    height: 1.74rem;
    background: url(../assets/bg91.png) no-repeat 0 0 / 100% 100%;
    z-index: 2000;
    span:nth-child(1){
      position: absolute;
      left:0.37rem;
      top:0;
      width: 2.4rem;
      height: 1.03rem;
    }
    span:nth-child(2){
      position: absolute;
      right:0.37rem;
      top:0;
      width: 4.15rem;
      height: 1.03rem;
    }
  }
  .btn2{
    position: fixed;
    left:0;
    bottom:0;
    width: 100%;
    height: 1.74rem;
    background: url(../assets/bg90.png) no-repeat 0 0 / 100% 100%;
    z-index: 2000;
    span:nth-child(1){
      position: absolute;
      left:0.37rem;
      right:0.37rem;
      top:0;
      height: 1.03rem;
    }
  }
  // .d2{
  //   position: absolute;
  //   right:0;
  //   top:9.6rem;
  //   width: 0.52rem;
  //   height: 2.92rem;
  //   background: url(../assets/bg89.png) no-repeat 0 0 / 100% 100%;
  // }
  .d2{
    position: absolute;
    left: 0.12rem;
    top: 1.5rem;
    width: 0.52rem;
    height: 2.92rem;
    &::before{
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 0.52rem;
      height: 2.4rem;
      background: url(../assets/bg89_2.png) no-repeat 0 0 / 100% auto;
    }
    &::after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0.52rem;
      height: 0.5rem;
      background: url(../assets/bg89_2.png) no-repeat 0 100% / 100% auto;
      transform: scale(0.85);
      animation:1s linear infinite transformAni;
    }
    // background: url(../assets/bg89_2.png) no-repeat 0 0 / 100% 100%;
    // // animation:1s linear infinite d2Ani;
    // transform: scale(0.95);
    // animation:1s linear infinite transformAni;
  }
  .d3{
    .b1{
      margin: 0 auto 0.95rem;
      width: 6.9rem;
      height: 0.52rem;
      background: url(../assets/bg95.png) no-repeat 0 0 / 100% 100%;
    }
    .item{
      position: relative;
      width: 6.62rem;
      height: 1.87rem;
      margin:-0.46rem auto 0;
      background: url(../assets/bg96.png) no-repeat 0 0 / 100% 100%;
      overflow: hidden;
      .ut,.pt{
        position: absolute;
        left:0.12rem;
        top:0.22rem;
        width: 0.97rem;
        height: 0.97rem;
        border-radius: 100%;
      }
      .pt{
        left:auto;
        right:0.14rem;
      }
      .un,.pn{
        position: absolute;
        left:1.2rem;
        top:0;
        width: 0.96rem;
        height: 1.42rem;
        font-size: 0.22rem;
        line-height: 1.42rem;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        text-align: left;
      }
      .pn{
        left:auto;
        text-align: right;
        right:1.18rem;
      }
      .num{
        position: absolute;
        left:2.46rem;
        top:0.1rem;
        width: 1.1rem;
        height: 0.72rem;
        font-size: 0.5rem;
        line-height: 0.8rem;
        text-align: right;
        font-weight: bold;
        font-style: italic;
      }
    }
    .item2{
      background: url(../assets/bg97.png) no-repeat 0 0 / 100% 100%;
    }
    .item3{
      background: url(../assets/bg98.png) no-repeat 0 0 / 100% 100%;
    }
    .item4{
      background: url(../assets/bg99.png) no-repeat 0 0 / 100% 100%;
    }
    .item5{
      background: url(../assets/bg100.png) no-repeat 0 0 / 100% 100%;
    }
  }
  .d4{
    height: 1.74rem;
  }
  .d5{
    position: fixed;
    left:0;
    top:0;
    bottom:0;
    right:0;
    background: rgba($color: #000000, $alpha: 0.8) url(../assets/bg101.png) no-repeat 95% 0.5rem / 2.05rem 2.23rem;
    z-index: 10000;
  }
}
@keyframes d2Ani {
  100%{
    opacity: 0.5;
  }
}
</style>
